export default __webpack_public_path__ + "static/media/extra_out_r4.755bf164.svg";